import * as yup from 'yup';

export const formFields = {
  search: 'query',
};

export const filterSchema = yup.object().shape({
  [formFields.search]: yup.string(),
});
